import type { AccommodationFormData } from '@/pages/accommodation/types'
import { useGetRmcCompaniesQuery } from '@/slices/companies'
import type { BaseOptionType } from '@/UIkit/Select'

import type { Path, UseFormWatch } from 'react-hook-form'

export const useCompany = (watch: UseFormWatch<AccommodationFormData>) => {
  const id = watch(
    'company.value' as Path<AccommodationFormData>
  ) as BaseOptionType<Number>

  const { data: rmcCompanies } = useGetRmcCompaniesQuery(
    { ids: [Number(id?.value || id)] },
    { skip: !id?.value }
  )

  const company = rmcCompanies?.items?.[0]

  return company
}
